import type { RouteRecordRaw } from 'vue-router';
import { mdiLock } from '@mdi/js';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const resetPasswordInvalidRoutes = {
  name: 'reset-password-invalid',
  path: 'reset-password-invalid',
  components: {
    default: () => import('./ResetPasswordInvalid.vue'),
    brand: () => import('./ResetPasswordInvalidBrand.vue'),
  },
  meta: {
    i18n,
    authHeader: {
      titleKey: 'resetPasswordInvalid.invalidTokenTitle',
      subtitleKey: 'resetPasswordInvalid.invalidTokenDesc',
      icon: { name: mdiLock, tone: 'negative' },
      announce: 'alert',
    },
  },
} satisfies RouteRecordRaw;
